import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    useDispatch,
    useSelector,
} from 'react-redux';

import {
    withRouter,
} from 'react-router';

import {
    Col,
} from '@zillow/zrs-comet';

import { RMWContext } from 'app/shared/providers/RMWContext';

// Selectors
import {
    RoutingSelectors,
} from 'app/shared/selectors';

import LeadActions from 'app/shared/actions/LeadActions';

import { GA_EVENTS_INTERESTED_RENTERS_MODULE } from 'app/shared/constants/AnalyticsConstants';

import analyticsUtils from 'app/client/utils/analyticsUtils';

import { StyledHeading } from 'app/shared/components/ConnectedInterestedRenters/StyledComponents';

import {
    StyledCard,
    StyledColHiddenOnXs,
    StyledIconChevronRightCircle,
    StyledLabel,
    StyledRow,
} from './StyledComponents';

const propTypes = {
    updateMinModuleHeight: PropTypes.func,
};

const defaultProps = {
    updateMinModuleHeight: () => {},
};

const CARD_LABELS = {
    NEW: ' New',
    NOT_REPLIED_TO: ' Not replied to',
    TOTAL: ' Total',
};

const {
    NEW_INQUIRIES_CLICK,
    UN_REPLIED_INQUIRIES_CLICK,
    TOTAL_INQUIRIES_CLICK,
} = GA_EVENTS_INTERESTED_RENTERS_MODULE;

const ConnectedInquiries = ({ updateMinModuleHeight }) => {
    const { paths } = useContext(RMWContext);
    const dispatch = useDispatch();
    const listingId = useSelector(state => RoutingSelectors.makeListingId(state));

    const [inquiryCounts, setInquiryCounts] = useState({
        unreadCount: 0,
        notRepliedToCount: 0,
        totalConversationsCount: 0,
    });

    useEffect(() => {
        dispatch(LeadActions.getConversationCountsForListing({ listingAlias: listingId }))
            .then((res) => {
                const {
                    unreadCount,
                    notRepliedToCount,
                    totalConversationsCount,
                } = res;

                setInquiryCounts({
                    unreadCount,
                    notRepliedToCount,
                    totalConversationsCount,
                });
            }).finally(() => {
                updateMinModuleHeight();
            });
    }, [dispatch, listingId]);

    const {
        unreadCount,
        notRepliedToCount,
        totalConversationsCount,
    } = inquiryCounts;

    const triggerGAEvent = (label, value) => {
        let gaEvent = {};

        switch (label) {
            case CARD_LABELS.NEW:
                gaEvent = NEW_INQUIRIES_CLICK;
                break;
            case CARD_LABELS.NOT_REPLIED_TO:
                gaEvent = UN_REPLIED_INQUIRIES_CLICK;
                break;
            case CARD_LABELS.TOTAL:
                gaEvent = TOTAL_INQUIRIES_CLICK;
                break;
            default:
                console.warn('No case for', label);
                break;
        }

        dispatch(analyticsUtils.track.GAEventV2({
            ...gaEvent,
            value,
        }));

        return false;
    };

    const handleCardClick = (filter = '', label = '', count = 0) => {
        // always filter with byProperty
        const queryParams = filter ? `?${filter}=true&byProperty=true` : '?byProperty=true';

        triggerGAEvent(label, count);
        window.router.updateLocation(`${paths.base}/inbox/${listingId}${queryParams}`);
    };

    return (
        <div className="ConnectedInquiries">
            <StyledHeading level={3} paddingBottom="sm">
                Inquiries
            </StyledHeading>

            <StyledRow>
                <Col xs={6} lg={12}>
                    <StyledCard
                        onClick={() => handleCardClick(
                            'unreadOnly',
                            CARD_LABELS.NEW,
                            unreadCount
                        )}
                        cardType="secondary"
                        marginRight="xs"
                    >
                        <StyledLabel>
                            <strong>
                                {unreadCount}
                            </strong>
                            { CARD_LABELS.NEW }
                        </StyledLabel>

                        <StyledIconChevronRightCircle size="sm" />
                    </StyledCard>
                </Col>

                <StyledColHiddenOnXs xs={6} lg={12}>
                    <StyledCard
                        onClick={() => handleCardClick(
                            'notRepliedToOnly',
                            CARD_LABELS.NOT_REPLIED_TO,
                            notRepliedToCount
                        )}
                        cardType="secondary"
                        marginLeft="xs"
                    >
                        <StyledLabel>
                            <strong>
                                {notRepliedToCount}
                            </strong>

                            {CARD_LABELS.NOT_REPLIED_TO}
                        </StyledLabel>

                        <StyledIconChevronRightCircle size="sm" />
                    </StyledCard>
                </StyledColHiddenOnXs>

                <Col xs={6} lg={12}>
                    <StyledCard
                        onClick={() => handleCardClick(
                            '',
                            CARD_LABELS.TOTAL,
                            totalConversationsCount
                        )}
                        cardType="secondary"
                    >
                        <StyledLabel>
                            <strong>
                                { totalConversationsCount }
                            </strong>

                            { CARD_LABELS.TOTAL }
                        </StyledLabel>

                        <StyledIconChevronRightCircle size="sm" />
                    </StyledCard>
                </Col>
            </StyledRow>
        </div>
    );
};

ConnectedInquiries.propTypes = propTypes;
ConnectedInquiries.defaultProps = defaultProps;

export default withRouter(ConnectedInquiries);
